import discardBlockedDomainsOption from './actions/discardBlockedDomainsOption';
import saveBlockedDomainsOption from './actions/saveBlockedDomainsOption';
import BlockedDomainsFull from './components/BlockedDomainsFull';
import isBlockedDomainsOptionDirty from './utils/isBlockedDomainsOptionDirty';
import * as React from 'react';
var BlockedDomainsOption = {
    key: 'blockedDomains',
    titleStringKey: 'optionTitle_blockedDomains',
    searchTermsStringKey: 'optionSearchTerms_blockedDomains',
    fullOptionFormSettings: {
        render: function () { return React.createElement(BlockedDomainsFull, null); },
        isDirty: isBlockedDomainsOptionDirty,
        onSave: saveBlockedDomainsOption,
        onDiscard: discardBlockedDomainsOption,
    },
};
export default BlockedDomainsOption;
//# sourceMappingURL=BlockedDomainsOption.js.map